(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenum-collection-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      section.querySelectorAll('[data-cross-sell-group]').forEach((group) => {
        const templates = Array.from(group.querySelectorAll('[data-cross-sell-template]'));
        const slot = group.querySelector('[data-cross-sell-slot]');
        if (!slot || templates.length === 0) return;

        const storageKey = `zenum-cross-sell-${section.dataset.sectionId}-${group.dataset.crossSellCollection}`;
        let selectedIndex = Number.parseInt(sessionStorage.getItem(storageKey), 10);

        if (!Number.isInteger(selectedIndex) || selectedIndex < 0 || selectedIndex >= templates.length) {
          if (window.crypto?.getRandomValues) {
            const value = new Uint32Array(1);
            window.crypto.getRandomValues(value);
            selectedIndex = value[0] % templates.length;
          } else {
            selectedIndex = Math.floor(Math.random() * templates.length);
          }

          try {
            sessionStorage.setItem(storageKey, String(selectedIndex));
          } catch (error) {
            selectedIndex = Math.max(0, selectedIndex);
          }
        }

        slot.replaceChildren(templates[selectedIndex].content.cloneNode(true));
      });

      const track = section.querySelector('[data-cross-sell-track]');
      const cards = Array.from(section.querySelectorAll('[data-cross-sell-group]'));
      const current = section.querySelector('[data-cross-sell-current]');
      const previous = section.querySelector('[data-cross-sell-previous]');
      const next = section.querySelector('[data-cross-sell-next]');
      if (!track || cards.length === 0 || !current || !previous || !next) return;

      const getGap = () => Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const getStep = () => cards[0].getBoundingClientRect().width + getGap();
      const getIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / getStep())));
      const update = () => {
        current.textContent = String(getIndex() + 1).padStart(2, '0');
      };
      const go = (direction) => {
        const index = Math.max(0, Math.min(cards.length - 1, getIndex() + direction));
        track.scrollTo({ left: index * getStep(), behavior: 'smooth' });
      };

      previous.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));

      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };

    document.querySelectorAll('[data-zenum-cross-sell]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      initialise(event.target.querySelector('[data-zenum-cross-sell]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
